module.exports = __webpack_public_path__ + "img/ic_light_purple.657c6649.png";